import {useActions, useGetters, useMutators, useState} from './_default';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        ...useState(),
        list: {},
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        load({ state }, { lat, lng, hash }) {
            const key = `${lat}:${lng}`;
            if (state.list[key]) return state.list[key];

            state.list[key] = new Promise((resolve, reject) => {
                axios.get(hash ? `/sharing/${hash}/address` : '/address', {
                    params: { lat, lon: lng }
                }).then((response) => {
                    state.list[key] = new Promise((resolve) => resolve(response.data));
                    resolve(response.data);
                }).catch((error) => {
                    state.list[key] = null;
                    if (error?.response?.data?.message) {
                        return reject(error?.response?.data?.message);
                    }

                    if (error?.message) {
                        return reject(error?.message);
                    }
                    reject('Error');
                });
            });
            return state.list[key];
        }
    },
}
